// extracted by mini-css-extract-plugin
export default {"form":"registerStep_form__25RK0","error":"registerStep_error__a7CVg"};